import React, { useEffect, useState } from 'react';
import Button from 'web/components/Button';
import { useHistory } from 'react-router-dom';
import * as moment from 'moment';
import { FORMAT } from 'web/components/utils/dateOfBirthValidation';
import { useDispatch } from 'react-redux';
import { MyOffersMobileViewWrapper } from '../myPostStyled';
import CurrencyFormat from 'react-currency-format';
import DownArrow from 'web/assets/svg/AccordionDownArrow';
import UpArrow from 'web/assets/svg/AccordionUpArrow';

const MobileView = (props) => {
    const { offerType, apiResponse, currentPageNumber, declineOfferFunction, timeFormat, pageLanguageContents, tootTip, filterState } = props
    const [isOpen, setIsOpen] = useState([]);
    const dispatch = useDispatch();
    const history = useHistory();
    const [pageData, setPageData] = useState()

    const toggleAccordion = (index) => {
        const newIsOpen = [...isOpen];
        newIsOpen[index] = !newIsOpen[index];
        setIsOpen(newIsOpen);
    };

    const capitalizeFirstLetter = str => str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();

    useEffect(() => {
        if (offerType === 'BuyNowCpu') setPageData(apiResponse.pickupOfferDetails)
        else if (offerType === 'BuyNow') setPageData(apiResponse.buyNowOfferDetails)
        else if (offerType === 'Offers') setPageData(apiResponse.offerDetails)
    }, [offerType])

    return (
        <MyOffersMobileViewWrapper>
            {pageData?.map((items, index) => (
                <div key={index} className={`mobile-accordion ${isOpen[index] ? 'open' : ''}`}>
                    <div className="accordion-header" onClick={() => toggleAccordion(index)}>
                        <div className="accordion-header-left">
                            <div className="info">
                                <h6>Buyer Located Near</h6>
                                <p>{items.companyInfo}</p>
                            </div>
                            <div className="info">
                                <h6>Offer Price</h6>
                                <p>{items.offerPrice && <CurrencyFormat value={items.offerPrice.toFixed(2)} displayType={'text'} thousandSeparator={true} prefix={'$'} />}</p>
                            </div>
                        </div>
                        <div className="accordion-header-right">
                            <p>{isOpen[index] ? <UpArrow /> : <DownArrow />}</p>
                        </div>
                    </div>
                    {isOpen[index] && (
                        <div className="accordion-content">
                            <div className="accordion-column">
                                <div className="info-header">
                                    <div className="info">
                                        <h6>{offerType === 'Offers' ? 'Date' : offerType === 'BuyNowCpu' ? 'Pickup Date' : 'Delivery Date'}</h6>
                                        <p>{items.outsideWorkingDays ? <span className="orangeStatus">{moment(items.requestedDate).format(FORMAT)}{tootTip()}</span> : <span>{moment(items.requestedDate).format(FORMAT)}</span>}</p>
                                    </div>
                                    <div className="info">
                                        <h6>{offerType === 'Offers' ? 'Time' : offerType === 'BuyNowCpu' ? 'Pickup Time' : 'Delivery Time'}</h6>
                                        <p>{timeFormat(items.appointmentStartTime)} - {timeFormat(items.appointmentEndTime)}</p>
                                    </div>
                                </div>
                                <div className="info-header">
                                    <div className="info">
                                        <h6>Qty</h6>
                                        <p><CurrencyFormat value={items.qty || apiResponse.totalQty} displayType={'text'} prefix={''} /></p>
                                    </div>
                                    <div className="info">
                                        <h6>Offer Status</h6>
                                        <p>{items.offerStatusMessage}</p>
                                    </div>
                                </div>
                                <div className="info-header">
                                    {offerType === 'Offers' &&
                                        <div className="info">
                                            <h6>Mode</h6>
                                            <p>{capitalizeFirstLetter(items.shippingMode)}</p>
                                        </div>
                                    }
                                </div>
                            </div>
                            <div className="accordion-buttons">
                                {(items.offerStatusMessage?.toLowerCase()?.includes('accepted') || items.offerStatusMessage?.toLowerCase()?.includes('received')) &&
                                    <Button type='app-green-button' handleClick={() => {
                                        let obj = {
                                            id: items.offerId?.toString(),
                                            type: 'sellerInvCheckout'
                                        }
                                        dispatch({ type: 'CHECKOUT', payload: obj });
                                        let obj2 = { selectedPage: currentPageNumber, filterState: filterState };
                                        dispatch({ type: "BIDS_PAGINATION", payload: obj2 });
                                        history.push({ pathname: '/checkout' });
                                    }}>
                                        {pageLanguageContents?.Contents[28]?.View}
                                    </Button>
                                }
                                {(items.offerStatusMessage?.toLowerCase()?.includes('received')) &&
                                    <Button type='app-green-button' handleClick={() => declineOfferFunction(items.offerId)} >
                                        Decline
                                    </Button>
                                }
                            </div>
                        </div>
                    )}
                </div>
            ))}
        </MyOffersMobileViewWrapper>
    );
};

export default MobileView;
